export default __webpack_public_path__ + "static/media/small-animation.e3802bb5.gif";